export default "__VITE_ASSET__1c75f4cd__"